import { useQuery } from 'react-query';

import AssessmentService from 'App/services/AssessmentService';

function useFetchAssessmentRiskOptions(assessmentId) {
    return useQuery(
        ['assessmentId', assessmentId, 'riskOptions'],
        () => AssessmentService.getRiskOptions(assessmentId),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        }
    );
}

export default useFetchAssessmentRiskOptions;
